import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadDistributionModels = async () => {
  let response = await Axois.get('/analytic-distribution-models').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadDistributionModel = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/analytic-distribution-models');
        const responseData = await requests.data;
        return {analytics: responseData, distributionModel: {} };
      
      default:
        let response = await Axois.get('/analytic-distribution-models/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { analytics: [], journals: [], accounts: [], analyticItem: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const useAnalyticDistributionModelAPI = () => {
  
  const save = async (data, success) => {
    try {
      const response = await Axois.post('/analytic-distribution-models', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_model_response', responseData.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/analytic-distribution-models/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('analytic_model_response', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update };
}


export default useAnalyticDistributionModelAPI;